const history = (state = [], action) => {
    switch (action.type) {
      case 'HISTORY':
        return action.history.map(history => {
                  return history
                })
      default:
        return state
    }
  }
  
  export default history